import api from '../../../services/api';
import buildQuery from 'odata-query'

export const WORKFLOW_URL = '/workflow'

/**
 * Retorna a justificativa
 * @param {int} id 
 * @returns {Array}
 */
export function fetchJustification(id) {
    return api.get(`${WORKFLOW_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(id),
            situation: 'Disapproved'
        },
        select: "justification",
        orderby: "Id desc",
    }))
}

/**
 * Retorna se existe um workflow aberto para aquele padrao
 * @param {int} id 
 * @returns {boolean}
 */
export async function fetchOpenWorkflow(id, version) {
    const request  = await api.get(`${WORKFLOW_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(id),
            or: [
                { situation: 'Pending' },
                { situation: 'NotStarted' },
            ]
        },
        select: ['id'],
        expand: {            
            users: {
                select: ['situation']                
            }
        },
        count : true
    }))
    if (request.status == 200) {
        if (request.data._count > 0)
            return request.data.value[0];
    }
    return false;
}